<!-- 各区域排名 -->
<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body">
          <div class="fixed">
            <div class="header-order">{{ $t('序号') }}</div>
            <div class="header-item1">{{ $t('区域名称') }}</div>
            <div class="header-item2">{{ $t('完成情况') }}</div>
          </div>
          <div style="overflow: hidden;height: 100%;">
            <ul class="list-ul" v-if="list.length>0">
              <li class="list-row" v-for="(item, index) in list" :key="index" >
                <div class="list-order">
                  <div class="order" :style="{background:index>2?'#66BAF8':''}">
                    {{ `NO.${index+1}` }}
                  </div>
                </div>
                <div class="list-item1">{{ item.planName}}</div>
                <div class="list-item2">
                  <a-progress strokeColor="#69D389" :percent="item.taskFinishRate?(item.taskFinishRate*100).toFixed(2):0" :strokeWidth="12" :show-info="false" class="wcqk" />
                  {{item.taskFinishRate?(item.taskFinishRate*100).toFixed(0):0}}%
                </div>
              </li>
            </ul>
            <div style="height: 100%;display: flex;justify-content: center;align-items: center;" v-else>
              <i>{{ $t('暂无数据') }}</i>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import { postAction } from '@/api/manage'
export default {
    data() {
        return{
            title: this.$t('本月各区域排名'),
            url:{
              LargeScreenSumAreaRankByTime: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumAreaRankByTime",
            },
            list:[
              // {name:'名称1',wcqk:34},
              // {name:'名称1',wcqk:44},
              // {name:'名称1',wcqk:55},
              // {name:'名称1',wcqk:44},
              // {name:'名称1',wcqk:44},
            ],
        }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.LargeScreenSumAreaRankByTime,{queryType:1}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list = data;
          }
        })
      }
    },
}
</script>
<style lang="less" scoped>
  .fixed {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    background-color: #08306F;
    // margin: 10px 3px;
    // padding: 0 10px;
    color: #FFF;
    height: 30px;
  
    .header-item1 {
      width: 35%;
      text-align: center;
    }
    .header-item2 {
      width: 50%;
      text-align: center;
    }
  
    .header-order {
      width: 15%;
      text-align: center;
    }
  }
  
  .plant-bg {
    height: calc(100% - 40px);
    overflow: hidden;
    // background: url(../../../assets/img/plant5.png) center center no-repeat;
    // background-size: 100% 100%;
  }
  
  .list-ul {
    /* width: 100%;
      background: #f67;
      display: flex;
      justify-content: space-between; */
  }
  
  .list-row {
    // margin: 0 20px;
    color: #b6deff;
    display: flex;
    height: 33px;
    align-items: center;
    line-height: 35px;
    border: 1px solid #011a3a;
    // background: url(../../../assets/img/list-bg.png) center no-repeat;
    // background-size: 100% 100%;
  
    .order {
      background: #FA6400;
      width: 48px;
      height: 18px;
      // border: 1px solid rgba(250,100,0,0.5);
      border-radius: 2px;
      text-align: center;
      line-height: 18px;
      color: #fff;
    }
  }
  
  .list-row .list-item1 {
    width: 35%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: #fff;
  }
  .list-row .list-item2 {
    width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // text-align: center;
    color: #fff;
    padding: 0 24px 0 15px ;
  }
  
  .list-order {
    width: 15%;
    display: flex;
    justify-content: center;
  }
  
  .fill-cicle {
    height: 10px;
    width: 10px;
    border-radius: 10px;
    box-shadow: 0 0 5px 5px rgba(255, 0, 0, 0.5);
  }
  
  ul {
    padding-inline-start: 0;
  }
  
  .seamless-warp {
    height: 100%;
  }
  
  .seamless-warp:hover {
    overflow-y: scroll;
  }
  
  .seamless-warp::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .seamless-warp::-webkit-scrollbar-track {
    background: #0e0c4f;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-thumb {
    background: #292f88;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-corner {
    background: #0e0c4f;
  }
  /deep/.wcqk .ant-progress-inner {
    background-color: #20515B;
  }
  /deep/.ant-progress-text{
    color: #fff;
  }
  .ant-progress-line{
    width: 70%;
  }
</style>